
import {
    Table,
    Label,
    Icon,
    Header,
    Image,
} from 'semantic-ui-react';

import { Link } from "react-router-dom";

import { useState, useCallback } from 'react';

import { gql, useMutation } from '@apollo/client';

import { StatusUpdater } from '../SessionUpdater';

import { PATHS } from "../../paths";

import { FULL_STATUS_OPTIONS } from "../../constants";

import { PrintRoleForSessionButton } from "./RolePrint";
import { PersonCourseAttendance } from './PersonCourseAttendance';

import { useIsAdmin } from "../../hooks/isAdmin";

const DELETE_ATTENDANCE = gql`
mutation DeleteAttendance($attendanceId: Int) {
  deleteAttendance(attendanceId: $attendanceId) {
    status
  }
}`;

const Session = ({ session , canEditCourse, refetchCourse }: { session: any, canEditCourse:any, refetchCourse: any }) => {
  const isAdmin = useIsAdmin();
  const [triggerRefetch, setTriggerRefetch] = useState(true);

  const [deleteAttendance] = useMutation(DELETE_ATTENDANCE);

  if (!session) {
      return null;
  }

  const handleDelete = async (id: number) => {
      await deleteAttendance({ variables: {
          attendanceId: id,
      }})

      refetchCourse();
  }

  // Check if the session startTime is in the last 12 hours or if the startTime is in the next 60 minutes
  const isInRange =
    new Date(Number(session.startTime)) > new Date(Date.now() - 36 * 60 * 60 * 1000)
    && new Date(Number(session.startTime)) < new Date(Date.now() + 60 * 60 * 1000);

  return (
      <div>
          <Label size='small'>
            <Icon name='time' /> {session.durationMinutes} minutes
          </Label>
          <PrintRoleForSessionButton sessionId={session.id} />
          <Table celled >
            <Table.Body>
                {session.attendance.map((a: any) => {
                    return (
                        <Table.Row key={a.id}>
                            <Table.Cell width={1}>
                            <Header as='h4' image>
                                <Header.Content>
                                  {/* Photo */}
                        <Image avatar src={a.user.photoUrl} size='tiny' style={{ width: '3em', height: '3em', objectFit: 'cover' }}/>
                                  {/* Name */}
                                  <Link to={`${PATHS.PEOPLE}/${a.user.id}`}>
                                    {a.user.name} ({a.user.identifier})
                                  </Link>
                                  {/* Attendance percentage */}
                                  {" (Attendance: "}
                                  <PersonCourseAttendance
                                    personId={Number(a.user.id)}
                                    triggerRefetch={triggerRefetch}
                                    courseId={session.course.id} />
                                  {")"}

                                    {isAdmin && (<>
                                          <Icon color='red' name='trash alternate outline' onClick={() => handleDelete(a.id)} />
                                      </>
                                      )}
                                  </Header.Content>
                              </Header>
                              </Table.Cell>
                              <Table.Cell width={1}>
                                {((canEditCourse && isInRange) || isAdmin) ? (
                                  <StatusUpdater
                                    refetch={() => {
                                        setTriggerRefetch(!triggerRefetch)
                                        refetchCourse();
                                    }}
                                    sessionId={session.id}
                                    userId={a.user.id}
                                    initStatus={a.status}
                                    initDetails={a.details}
                                  />
                                  ) : (
                                    <>
                                      {FULL_STATUS_OPTIONS.find(s => s.value === a.status)?.text} {a.details?.length > 0 ? `: ${a.details}`: ''}
                                    </>
                                  )
                                }
                              </Table.Cell>
                          </Table.Row>
                      )
                  })}
              </Table.Body>
          </Table>
        </div>
    )
  }

  export { Session }
